// import Seo from '@/components/Seo/Seo'
import {
  Backdrop,
  Box,
  Button,
  Dialog,
  Snackbar,
  Tab,
  Tabs,
} from "@mui/material";
import styles from "../../../styles/pages/user/copywriter-dashboard.module.scss";
import React, { useMemo, useState } from "react";
import UserTitlingIcon from "../../../ui/Icons/UserTitlingIcon";
import UserRevisionIcon from "../../../ui/Icons/UserRevisionIcon";
import UserCompleteVideoIcon from "../../../ui/Icons/UserCompleteVideoIcon";
import UserMessageIcon from "../../../ui/Icons/UserMessageIcon";
import UserCopyWriterWrapper from "../../../layout/userwrapper/UserCopyWriterWrapper";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import UserCommonDropDown from "../../../components/UserCommonDropDown/UserCommonDropDown";
// import Image from 'next/image'
import assest from "../../../json/assest";
import UserCalenderDate from "../../../components/UserCalenderDate/UserCalenderDate";
import UserCopywriterVideoTitling from "../../../components/UserCopywriterVideoTitling/UserCopywriterVideoTitling";
import CopywriterDashboardFeedbackModal from "../../../components/CopywriterDashboard/CopywriterDashboard/CopywriterDashboardFeedbackModal/CopywriterDashboardFeedbackModal";
import UserCrossIcon from "../../../ui/Icons/UserCrossIcon";
import { borderRadius } from "@mui/system";
import CopyWriterDashboardWrapper from "../../../layout/wrapper/CopyWriterDashboardWrapper";
import {
  Copywriterssubmissionsmutation,
  getcopywritersdashboardSubmission,
  totalvideoListCopywritersDashboard,
  totalvideoListCopywritersDashboard1,
} from "../../../api/functions/copywritersDashboard.api";
import { useInfiniteQuery, useMutation, useQuery } from "react-query";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcTime,
} from "../../../lib/functions/utils.lib";
import moment from "moment";
import LatestRevision from "./Components/LatestRevision";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import {
  copywriterssubmissionData,
  submissionData,
} from "../../../api/functions/manager.api";
import { Link, Navigate, useNavigate } from "react-router-dom";
import SeeAllButton from "../../../ui/Icons/SeeAllButton";
import UrgentTitiling from "./Components/UrgentTitiling";

const listingLoop = [
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Alerted by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(Admin)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Alerted by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(QC Agent)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Alerted by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(QC Agent)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Alerted by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(QC Agent)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Alerted by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(QC Agent)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Alerted by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(QC Agent)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Alerted by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(QC Agent)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Alerted by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(QC Agent)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Alerted by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(QC Agent)",
  },
];

const listingLoopRevision = [
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Requested by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(Admin)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Requested by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(Admin)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Requested by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(Admin)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Requested by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(Admin)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Requested by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(Admin)",
  },
  {
    image: `${assest.titlingImg}`,
    vsid: "VSID:",
    vsidSpan: "20135",
    pending: "Pending since:",
    pendingSpan: "September 26, 2019 at 05:45:23 AM UTC",
    alert: "Requested by:",
    alertSpan: "Theodoulke Tadris",
    agent: "(Admin)",
  },
];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CopywriterDashboard = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /***************feedbackModal****************/

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickClose = () => {
    setOpen(false);
  };
  const handleClose = (value) => {
    setOpen(false);
  };

  /****************feedbackModal***************/

  const { data, fetchNextPage, hasNextPage, refetch, isLoading } =
    useInfiniteQuery({
      queryKey: [
        "totalvideoListCopywritersDashboard",
        // search, status1, date
      ],
      queryFn: ({ pageParam = 1 }) => {
        return totalvideoListCopywritersDashboard(pageParam);
      },
      keepPreviousData: true,
      enabled: true,

      getNextPageParam: (lastPage, allPages) => {
        if (
          allPages[allPages.length - 1 || 0].current_page <
          allPages[0]?.last_page
        ) {
          // console.warn(allPages[0].current_page + 1, "sdadasdas");
          // Assuming lastPage.length represents the number of items on the current page
          // You may need to adjust this logic based on your API response structure
          return allPages[allPages.length - 1 || 0].current_page + 1;
        } else {
          return undefined;
        }
      },
    });

  /* The above code is using the `useMemo` hook in React to process some data. */
  const processed_data = useMemo(() => {
    var dat = { data: [] };
    data?.pages?.forEach((item) => {
      dat = { ...item, data: [...dat.data, ...item?.data] };
    });
    return dat;
  }, [data]);

  const navigate = useNavigate();

  const sendData = (event) => {
    navigate(`/copywriter-dashboard/pending-titling-page?urgent_request=1`);
  };

  // const { mutate: mutating } = useMutation(getcopywritersdashboardSubmission);

  // useEffect(() => {
  //   const managerId = {
  //     copyright_id: props.selectedId,
  //     from: date?.startDate,
  //     to: date?.endDate,
  //   };
  //   mutating(managerId, {
  //     onSuccess: (data) => {
  //       // console.warn(data, "managerId")
  //       setManagerCardSubmissionData(data);
  //     },
  //   });
  // }, [date]);

  const { data: submissionList } = useQuery(
    ["VIDEOList"],

    async () => {
      return Copywriterssubmissionsmutation({
        // pending_titling: 1,
        // page: page,
      });
    }
  );

  return (
    <>
      {isLoading ? (
        <ApiLoader loading={isLoading} />
      ) : (
        <CopyWriterDashboardWrapper chatbtn={true}>
          {/* <Seo title="Copywriter Dashboard" canonical={''} description={''} url={''} image={''} /> */}

          <Box className="main_body">
            <Box className={styles.copywriterWrapper}>
              <Box className={styles.copywriterTab}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label={
                      <>
                        <Box
                          class={styles.copywriteTab}
                          onClick={() =>
                            navigate(
                              "/copywriter-dashboard/pending-titling-page"
                            )
                          }
                        >
                          <Box className={styles.tabItem}>
                            <Box className={styles.tabitemImg}>
                              <UserTitlingIcon />
                            </Box>

                            <p>
                              Pending Titling
                              {submissionList?.data?.submissions
                                ?.pendingTitling !== 0 ? (
                                <>
                                  <span>
                                    {
                                      submissionList?.data?.submissions
                                        ?.pendingTitling
                                    }
                                  </span>
                                </>
                              ) : (
                                <span>-</span>
                              )}
                            </p>
                          </Box>
                        </Box>
                      </>
                    }
                    {...a11yProps(0)}
                  />

                  <Tab
                    label={
                      <>
                        <Box
                          class={styles.copywriteTab}
                          onClick={() =>
                            navigate(
                              "/copywriter-dashboard/pending-titling/revised"
                            )
                          }
                        >
                          <Box className={styles.tabItem}>
                            <Box className={styles.tabitemImg}>
                              <UserRevisionIcon />
                            </Box>

                            <p>
                              Pending Revision
                              {submissionList?.data?.submissions
                                ?.pendingRevision !== 0 ? (
                                <>
                                  {" "}
                                  <span>
                                    {
                                      submissionList?.data?.submissions
                                        ?.pendingRevision
                                    }
                                  </span>
                                </>
                              ) : (
                                <span>-</span>
                              )}
                            </p>
                          </Box>
                        </Box>
                      </>
                    }
                    {...a11yProps(1)}
                  />

                  <Tab
                    label={
                      <>
                        <Box
                          class={styles.copywriteTab}
                          onClick={() =>
                            navigate("/copywriter-dashboard/completed-videos")
                          }
                        >
                          <Box className={styles.tabItem}>
                            <Box className={styles.tabitemImg}>
                              <UserCompleteVideoIcon />
                            </Box>

                            <p>
                              Completed Videos
                              {submissionList?.data?.submissions
                                ?.Completed_videos !== 0 ? (
                                <>
                                  <span>
                                    {
                                      submissionList?.data?.submissions
                                        ?.Completed_videos
                                    }
                                  </span>
                                </>
                              ) : (
                                <span>-</span>
                              )}
                            </p>
                          </Box>
                        </Box>
                      </>
                    }
                    {...a11yProps(2)}
                  />

                  <Tab
                    label={
                      <>
                        <Box
                          class={styles.copywriteTab}
                          onClick={() =>
                            navigate("/copywriter-dashboard/my-messages")
                          }
                        >
                          <Box className={styles.tabItem}>
                            <Box className={styles.tabitemImg}>
                              <UserMessageIcon />
                            </Box>

                            <p>
                              Open Messages
                              {submissionList?.data?.submissions
                                ?.open_message !== 0 ? (
                                <>
                                  <span>
                                    {
                                      submissionList?.data?.submissions
                                        ?.open_message
                                    }
                                  </span>
                                </>
                              ) : (
                                <span>-</span>
                              )}
                            </p>
                          </Box>
                        </Box>
                      </>
                    }
                    {...a11yProps(3)}
                  />
                </Tabs>
              </Box>

              <Box className={styles.copywriterBody}>
                <PerfectScrollbar>
                  <CustomTabPanel value={value} index={0}>
                    <Box className={styles.copywriterTabTitling}>
                      <Box className={styles.TitlingLeft}>
                        <Box className={styles.titlingList}>
                          <UrgentTitiling />
                          <LatestRevision />

                          {/* <Box className={`${styles.titlingListBox} ${styles.titlingListBoxNoItem}`}>
                                                        <Box className={styles.titlingListBoxHeader}>
                                                            <h4>Latest revision requests</h4>
                                                        </Box>
                                                        <Box className={styles.titlingListBoxBody}>
                                                            <p>You currently have no pending revision requests.</p>
                                                        </Box>
                                                    </Box> */}
                          {/* <Box className={styles.activeColleage}>
                                                                                <p>Another colleague is currently working on this video.</p>
                                                                            </Box> */}
                        </Box>
                      </Box>

                      <Box className={styles.TitlingRight}>
                        <Box className={styles.TitlingRightDate}>
                          <UserCalenderDate />
                        </Box>

                        <Box className={styles.videoTitlingSummary}>
                          <UserCopywriterVideoTitling
                            videoTitlingSummary={
                              submissionList?.data?.titling_summary
                            }
                          />
                        </Box>
                      </Box>
                    </Box>
                  </CustomTabPanel>

                  <CustomTabPanel value={value} index={1}></CustomTabPanel>

                  <CustomTabPanel value={value} index={2}></CustomTabPanel>

                  <CustomTabPanel value={value} index={3}></CustomTabPanel>
                </PerfectScrollbar>
              </Box>
            </Box>
          </Box>

          {/* ***************feedbackModal************** */}

          <Dialog
            onClose={handleClose}
            open={open}
            className="copywriterDashboardfeedbackModal"
            sx={{
              "& .MuiDialog-container": {
                alignItems: "flex-start",
                marginTop: "72px",
              },
            }}
          >
            <CopywriterDashboardFeedbackModal />
            <Box className="closeFeedbackModal">
              <Button onClick={handleClickClose}>
                <UserCrossIcon />
              </Button>
            </Box>
          </Dialog>
        </CopyWriterDashboardWrapper>
      )}
    </>
  );
};

export default CopywriterDashboard;

// <CustomTabPanel value={value} index={1}>
// <Box className={styles.copywriterTabTitling}>
//   <Box className={styles.TitlingLeft}>
//     <Box className={styles.titlingList}>
//       <Box className={styles.titlingListItem}>
//         <Box
//           className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
//         >
//           <Box className={styles.titlingListBoxHeader}>
//             <UserCommonDropDown headingText="Urgent Titling Request" />
//           </Box>
//           <Box className={styles.titlingListBoxBody}>
//             <PerfectScrollbar>
//               {listingLoop.map((item, index) => {
//                 return (
//                   <Box
//                     className={
//                       styles.titlingListBoxItemMain
//                     }
//                     key={index}
//                     onClick={handleClickOpen}
//                   >
//                     <Box
//                       className={styles.titlingListBoxItem}
//                     >
//                       <Box
//                         className={
//                           styles.titlingListBoxItemImg
//                         }
//                       >
//                         <figure>
//                           <img
//                             src={item.image}
//                             alt=""
//                             width={100}
//                             height={62}
//                           />
//                         </figure>
//                       </Box>
//                       <Box
//                         className={
//                           styles.titlingListBoxItemTxt
//                         }
//                       >
//                         <p>
//                           {item.vsid}{" "}
//                           <span>{item.vsidSpan}</span>
//                         </p>
//                         <p>
//                           {item.pending}{" "}
//                           <span>{item.pendingSpan}</span>
//                         </p>
//                         <p>
//                           {item.alert}{" "}
//                           <span>{item.alertSpan}</span>{" "}
//                           <span className={styles.agent}>
//                             {item.agent}
//                           </span>
//                         </p>
//                       </Box>
//                     </Box>

//                     {/* <Box className={styles.activeColleage}>
//                                                             <p>Another colleague is currently working on this video.</p>
//                                                         </Box> */}
//                   </Box>
//                 );
//               })}
//             </PerfectScrollbar>
//           </Box>
//         </Box>
//       </Box>

//       <Box className={styles.titlingListItem}>
//         <Box className={styles.titlingListBox}>
//           <Box className={styles.titlingListBoxHeader}>
//             <UserCommonDropDown headingText="Latest revision requests" />
//           </Box>
//           <Box className={styles.titlingListBoxBody}>
//             <PerfectScrollbar>
//               {listingLoopRevision.map((item, index) => {
//                 return (
//                   <Box
//                     className={
//                       styles.titlingListBoxItemMain
//                     }
//                     key={index}
//                   >
//                     <Box
//                       className={styles.titlingListBoxItem}
//                     >
//                       <Box
//                         className={
//                           styles.titlingListBoxItemImg
//                         }
//                       >
//                         <figure>
//                           <img
//                             src={item.image}
//                             alt=""
//                             width={100}
//                             height={62}
//                           />
//                         </figure>
//                       </Box>
//                       <Box
//                         className={
//                           styles.titlingListBoxItemTxt
//                         }
//                       >
//                         <p>
//                           {item.vsid}{" "}
//                           <span>{item.vsidSpan}</span>
//                         </p>
//                         <p>
//                           {item.pending}{" "}
//                           <span>{item.pendingSpan}</span>
//                         </p>
//                         <p>
//                           {item.alert}{" "}
//                           <span>{item.alertSpan}</span>
//                           <span className={styles.agent}>
//                             {item.agent}
//                           </span>
//                         </p>
//                       </Box>
//                     </Box>

//                     {/* <Box className={styles.activeColleage}>
//                                                             <p>Another colleague is currently working on this video.</p>
//                                                         </Box> */}
//                   </Box>
//                 );
//               })}
//             </PerfectScrollbar>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   </Box>

//   <Box className={styles.TitlingRight}>
//     <Box className={styles.TitlingRightDate}>
//       <UserCalenderDate />
//     </Box>

//     <Box className={styles.videoTitlingSummary}>
//       <UserCopywriterVideoTitling />
//     </Box>
//   </Box>
// </Box>
// </CustomTabPanel>

// <CustomTabPanel value={value} index={2}>
// <Box className={styles.copywriterTabItem}>
//   <Box className={styles.copywriterTabTitling}>
//     <Box className={styles.TitlingLeft}>
//       <Box className={styles.titlingList}>
//         <Box className={styles.titlingListItem}>
//           <Box
//             className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
//           >
//             <Box className={styles.titlingListBoxHeader}>
//               <UserCommonDropDown headingText="Urgent Titling Requests" />
//             </Box>
//             <Box className={styles.titlingListBoxBody}>
//               <PerfectScrollbar>
//                 {listingLoop.map((item, index) => {
//                   return (
//                     <Box
//                       className={
//                         styles.titlingListBoxItemMain
//                       }
//                       key={index}
//                       onClick={handleClickOpen}
//                     >
//                       <Box
//                         className={
//                           styles.titlingListBoxItem
//                         }
//                       >
//                         <Box
//                           className={
//                             styles.titlingListBoxItemImg
//                           }
//                         >
//                           <figure>
//                             <img
//                               src={item.image}
//                               alt=""
//                               width={100}
//                               height={62}
//                             />
//                           </figure>
//                         </Box>
//                         <Box
//                           className={
//                             styles.titlingListBoxItemTxt
//                           }
//                         >
//                           <p>
//                             {item.vsid}{" "}
//                             <span>{item.vsidSpan}</span>
//                           </p>
//                           <p>
//                             {item.pending}{" "}
//                             <span>{item.pendingSpan}</span>
//                           </p>
//                           <p>
//                             {item.alert}{" "}
//                             <span>{item.alertSpan}</span>{" "}
//                             <span className={styles.agent}>
//                               {item.agent}
//                             </span>
//                           </p>
//                         </Box>
//                       </Box>

//                       {/* <Box className={styles.activeColleage}>
//                                                             <p>Another colleague is currently working on this video.</p>
//                                                         </Box> */}
//                     </Box>
//                   );
//                 })}
//               </PerfectScrollbar>
//             </Box>
//           </Box>
//         </Box>

//         <Box className={styles.titlingListItem}>
//           <Box className={styles.titlingListBox}>
//             <Box className={styles.titlingListBoxHeader}>
//               <UserCommonDropDown headingText="Latest revision requests" />
//             </Box>
//             <Box className={styles.titlingListBoxBody}>
//               <PerfectScrollbar>
//                 {listingLoopRevision.map((item, index) => {
//                   return (
//                     <Box
//                       className={
//                         styles.titlingListBoxItemMain
//                       }
//                       key={index}
//                     >
//                       <Box
//                         className={
//                           styles.titlingListBoxItem
//                         }
//                       >
//                         <Box
//                           className={
//                             styles.titlingListBoxItemImg
//                           }
//                         >
//                           <figure>
//                             <img
//                               src={item.image}
//                               alt=""
//                               width={100}
//                               height={62}
//                             />
//                           </figure>
//                         </Box>
//                         <Box
//                           className={
//                             styles.titlingListBoxItemTxt
//                           }
//                         >
//                           <p>
//                             {item.vsid}{" "}
//                             <span>{item.vsidSpan}</span>
//                           </p>
//                           <p>
//                             {item.pending}{" "}
//                             <span>{item.pendingSpan}</span>
//                           </p>
//                           <p>
//                             {item.alert}{" "}
//                             <span>{item.alertSpan}</span>{" "}
//                             <span className={styles.agent}>
//                               {item.agent}
//                             </span>
//                           </p>
//                         </Box>
//                       </Box>

//                       {/* <Box className={styles.activeColleage}>
//                                                             <p>Another colleague is currently working on this video.</p>
//                                                         </Box> */}
//                     </Box>
//                   );
//                 })}
//               </PerfectScrollbar>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </Box>

//     <Box className={styles.TitlingRight}>
//       <Box className={styles.TitlingRightDate}>
//         <UserCalenderDate />
//       </Box>

//       <Box className={styles.videoTitlingSummary}>
//         <UserCopywriterVideoTitling />
//       </Box>
//     </Box>
//   </Box>
// </Box>
// </CustomTabPanel>

// <CustomTabPanel value={value} index={3}>
// <Box className={styles.copywriterTabItem}>
//   <Box className={styles.copywriterTabTitling}>
//     <Box className={styles.TitlingLeft}>
//       <Box className={styles.titlingList}>
//         <Box className={styles.titlingListItem}>
//           <Box
//             className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
//           >
//             <Box className={styles.titlingListBoxHeader}>
//               <UserCommonDropDown headingText="Urgent Titling Requests" />
//             </Box>
//             <Box className={styles.titlingListBoxBody}>
//               <PerfectScrollbar>
//                 {listingLoop.map((item, index) => {
//                   return (
//                     <Box
//                       className={
//                         styles.titlingListBoxItemMain
//                       }
//                       key={index}
//                       onClick={handleClickOpen}
//                     >
//                       <Box
//                         className={
//                           styles.titlingListBoxItem
//                         }
//                       >
//                         <Box
//                           className={
//                             styles.titlingListBoxItemImg
//                           }
//                         >
//                           <figure>
//                             <img
//                               src={item.image}
//                               alt=""
//                               width={100}
//                               height={62}
//                             />
//                           </figure>
//                         </Box>
//                         <Box
//                           className={
//                             styles.titlingListBoxItemTxt
//                           }
//                         >
//                           <p>
//                             {item.vsid}{" "}
//                             <span>{item.vsidSpan}</span>
//                           </p>
//                           <p>
//                             {item.pending}{" "}
//                             <span>{item.pendingSpan}</span>
//                           </p>
//                           <p>
//                             {item.alert}{" "}
//                             <span>{item.alertSpan}</span>{" "}
//                             <span className={styles.agent}>
//                               {item.agent}
//                             </span>
//                           </p>
//                         </Box>
//                       </Box>

//                       {/* <Box className={styles.activeColleage}>
//                                                             <p>Another colleague is currently working on this video.</p>
//                                                         </Box> */}
//                     </Box>
//                   );
//                 })}
//               </PerfectScrollbar>
//             </Box>
//           </Box>
//         </Box>

//         <Box className={styles.titlingListItem}>
//           <Box className={styles.titlingListBox}>
//             <Box className={styles.titlingListBoxHeader}>
//               <UserCommonDropDown headingText="Latest revision requests" />
//             </Box>
//             <Box className={styles.titlingListBoxBody}>
//               <PerfectScrollbar>
//                 {listingLoopRevision.map((item, index) => {
//                   return (
//                     <Box
//                       className={
//                         styles.titlingListBoxItemMain
//                       }
//                       key={index}
//                     >
//                       <Box
//                         className={
//                           styles.titlingListBoxItem
//                         }
//                       >
//                         <Box
//                           className={
//                             styles.titlingListBoxItemImg
//                           }
//                         >
//                           <figure>
//                             <img
//                               src={item.image}
//                               alt=""
//                               width={100}
//                               height={62}
//                             />
//                           </figure>
//                         </Box>
//                         <Box
//                           className={
//                             styles.titlingListBoxItemTxt
//                           }
//                         >
//                           <p>
//                             {item.vsid}{" "}
//                             <span>{item.vsidSpan}</span>
//                           </p>
//                           <p>
//                             {item.pending}{" "}
//                             <span>{item.pendingSpan}</span>
//                           </p>
//                           <p>
//                             {item.alert}{" "}
//                             <span>{item.alertSpan}</span>{" "}
//                             <span className={styles.agent}>
//                               {item.agent}
//                             </span>
//                           </p>
//                         </Box>
//                       </Box>

//                       {/* <Box className={styles.activeColleage}>
//                                                             <p>Another colleague is currently working on this video.</p>
//                                                         </Box> */}
//                     </Box>
//                   );
//                 })}
//               </PerfectScrollbar>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </Box>

//     <Box className={styles.TitlingRight}>
//       <Box className={styles.TitlingRightDate}>
//         <UserCalenderDate />
//       </Box>

//       <Box className={styles.videoTitlingSummary}>
//         <UserCopywriterVideoTitling />
//       </Box>
//     </Box>
//   </Box>
// </Box>
// </CustomTabPanel>
